export const m = {
	header: {
		home: '首頁',
		company: '公司產品',
		corporate: '關於我們',
		products: '人才招聘',
		joinus: '聯係我們'
	},
	home: {
		moregame: '更多游戏',
		gameintro: '产品介绍',
		companyintro:'公司简介',
		moredetail:'更多详情',
		aboutcompany:'苏州爱洛克信息技术有限公司成立于2012年，注册资本1051万。总部位于苏州市工业园区，分别在香港、首尔、台北设立有分公司。发行区域涵盖东南亚、中国港澳台、北美等等。2015年，公司获得国内知名投资机构的投资，步入快速发展期。成为东南亚区域移动游戏发行领域的领军新锐。',
		sz:'苏州-总部',
		tw:'台北-分公司',
		xg:'香港-分公司',
		kr:'首尔-分公司',
		welcome:'欢迎优秀的你加入',
		joinus:'加入我们',
		aboutus:'创始团队均来自Activision Blizzard等知名游戏公司，平均从业10年以上，有丰富的AAA级游戏制作经验和发行经验。团队曾在中国及全球app store, Googleplay商店成功发行过多款Top 10游戏。'
	},
	company: {
		about: '公司介绍',
		content1: '苏州爱洛克信息技术有限公司成立于2012年，注册资本1051万。总部位于苏州市工业园区，分别在香港、首尔、台北设立有分支机构。创始团队均来自Activision Blizzard等知名游戏公司，平均从业10年以上，有丰富的AAA级游戏制作经验和发行经验。团队曾在中国及全球app store, Googleplay商店成功发行过多款Top 10游戏。发行区域涵盖东南亚、中国港澳台、北美等等。2015年，公司获得国内知名投资机构的投资，步入快速发展期。成为东南亚区域移动游戏发行领域的领军新锐。',
		content2: '苏州爱洛克信息技术有限公司在研发过程中，注重知识产权在企业竞争力中所起的重要作用。企业通过自主研发、产学研形式形成软件著作权29项，并在2016年被认定为国家高新技术企业和软件企业，2018年认定省隐形小巨人企业、瞪羚培育企业，同年，公司创始人邵珍荣获苏州工业园区领军人才的称号，2019年荣获国家文化出口重点企业资质。',
		head: '公司总部',
		issuing: '发行公司',
		history: '公司历程',
		game1: '小小主公',
		game2: '塔防三国志',
		game3: '超神学院',
		game4: '王牌制片人',
		game5: '乱斗英雄志',
		game6: '塔防三国志韩文版',
		game7: '小小主公2',
		game8: 'CODE:SEED星火之歌',
		team: '团队建设',
		pic1: '年礼',
		pic2:'年会节目',
		pic3:'桌游社活动',
		pic4:'7周年庆',
		pic5:'观影券',
		pic6:'公司场景',
		pic7:'旅游',
		pic8:'合照',
		pic9:'英语课堂',
		sz:'Suzhou',
		xg:'Hongkong',
		tb:'Taipei',
		hg:'Korea',
		dny:'Southeast Asia',
		bm:'North America'
	},
	culture: {
		cu: '企業文化',
		cv: '核心理念',
		td: '人才發展',
		we: '辦公環境',
		ea: '員工活動',
		vs: '願景',
		ms: '使命'
	},
	products: {
		gm: '產品業務',
		oc: '進入官網'
	},
	joinus: {
		ph: '联系方式',
		em: '企业邮箱',
		ad: '国内地址',
		tips:'简历投递方式： “姓名+投递岗位” 命名的个人简历投递到邮箱',
		require:'岗位职责',
		responsibility:'岗位要求',
		all:'모든'
	},
	footer: {
		lm: '了解更多',
		fu: '關注我們',
		cu: '聯繫我們',
		li: '法律信息',
		lo: '街景地圖',
		wx: '微信公眾號',
		cs: '客戶服務',
		pa: '合作洽談',
		sa: '服務協議',
		pp: '隱私政策',
		ip: '知識產權'
	}
}